import { Card, Radio, Text, useMantineTheme } from '@mantine/core';
import { useSearchFiltersContext } from 'context/SearchFilters.context';
import { TimeEnum } from 'enums';
import { handleSelection } from 'utils/filters/filters';
import { Actions, trackAction } from 'utils/amplitude';
import classes from './TimeSelector.module.scss';
import classNames from 'classnames';

const TimeSelector = () => {
  const theme = useMantineTheme();

  const { onFilterChange, timeSelected } = useSearchFiltersContext();

  const handleChange = (radioTime: TimeEnum) => {
    if (radioTime === TimeEnum.AM) {
      handleSelection(TimeEnum.AM, 'time', onFilterChange);
      trackAction(Actions.AM_SCHEDULE_SELECT);
    } else if (radioTime === TimeEnum.PM) {
      handleSelection(TimeEnum.PM, 'time', onFilterChange);
      trackAction(Actions.PM_SCHEDULE_SELECT);
    } else {
      handleSelection('', 'time', onFilterChange);
      trackAction(Actions.ALL_DAYS_SCHEDULE_SELECT);
    }
  };

  return (
    <Card className={classes.card}>
      <Text
        style={{
          fontSize: theme.spacing.sm,
          fontWeight: 700,
          color: theme.colors.gray[5],
          marginBottom: theme.spacing.sm,
        }}
      >
        Time
      </Text>
      <Radio.Group
        required
        value={timeSelected}
        onChange={(value) => handleChange(value as TimeEnum)}
      >
        <Radio
          classNames={{
            radio: classes.radio,
            label: classNames(classes.label, {
              [classes.activeLabel]: timeSelected === TimeEnum.ANY_TIME,
            }),
            body: classes.body,
            labelWrapper: classes.labelWrapper,
          }}
          value={TimeEnum.ANY_TIME}
          label="Any time"
        />
        <Radio
          classNames={{
            radio: classes.radio,
            label: classNames(classes.label, {
              [classes.activeLabel]: timeSelected === TimeEnum.AM,
            }),

            body: classes.body,
            labelWrapper: classes.labelWrapper,
          }}
          value={TimeEnum.AM}
          label="Morning"
        />
        <Radio
          classNames={{
            radio: classes.radio,
            label: classNames(classes.label, {
              [classes.activeLabel]: timeSelected === TimeEnum.PM,
            }),

            body: classes.body,
            labelWrapper: classes.labelWrapper,
          }}
          value={TimeEnum.PM}
          label="Afternoon"
        />
      </Radio.Group>
    </Card>
  );
};

export default TimeSelector;
